/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Banner counter */
const counters = document.querySelectorAll(".counter");

const options = {
  root: null,
  rootMargin: "0px",
  threshold: 0.5,
};

const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const target = +entry.target.getAttribute("data-target");
      const updateCounter = () => {
        const count = +entry.target.innerText;
        const increment = target / 200;
        if (count < target) {
          entry.target.innerText = `${Math.ceil(count + increment)}`;
          setTimeout(updateCounter, 1);
        } else {
          entry.target.innerText = target;
          observer.unobserve(entry.target); // Stop observing when target reached
        }
      };
      updateCounter();
    }
  });
}, options);
counters.forEach((counter) => {
  observer.observe(counter);
});

/* About Page Counter Js */

$(window).on("scroll", function () {
  var windowHeight = $(window).height(),
    windowTopPosition = $(window).scrollTop(),
    windowBottomPosition = windowTopPosition + windowHeight;

  $(".counting-section").each(function () {
    var $this = $(this),
      sectionTopPosition = $this.offset().top,
      sectionHeight = $this.height(),
      sectionBottomPosition = sectionTopPosition + sectionHeight;

    // Check if the section is in the viewport
    if (
      sectionBottomPosition >= windowTopPosition &&
      sectionTopPosition <= windowBottomPosition
    ) {
      $this.find(".counting").each(function () {
        var $counting = $(this),
          countTo = $counting.attr("data-count");
        $({ countNum: $counting.text() }).animate(
          {
            countNum: countTo,
          },
          {
            duration: 3000,
            easing: "linear",
            step: function () {
              $counting.text(Math.floor(this.countNum));
            },
            complete: function () {
              $counting.text(this.countNum);
            },
          }
        );
      });
    }
  });
});

/* About Us Page Team Slider */

$(document).ready(function () {
  $(".modern-slider").slick({
    autoplay: true,
    autoplaySpeed: 10000,
    slidesToShow: 4,
    slidesToScroll: 1,
    pauseOnHover: false,
    dots: false,
    pauseOnDotsHover: true,
    cssEase: "linear",
    draggable: true,
    prevArrow: $(".prev-arrow"),
    nextArrow: $(".next-arrow"),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

/* Product slider homepage */
$(document).ready(function () {
  var $carousel = $(".product-list-slide");
  var settings = {
    dots: false,
    arrows: true,
    slide: ".product-item",
    slidesToShow: 2,
    centerMode: true,
    centerPadding: "20%",
    responsive: [
      {
        breakpoint: 1367,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  function setSlideVisibility() {
    var visibleSlides = $carousel.find(".product-item");
    $(visibleSlides).each(function () {
      $(this).css("opacity", 1);
    });
    $(visibleSlides).first().prev().css("opacity", 0);
  }

  $carousel.slick(settings);
  $carousel.slick("slickGoTo", 1);
  setSlideVisibility();

  $carousel.on("afterChange", function () {
    setSlideVisibility();
  });
});

/* Information tabs */
$(function () {
  $(".container_delivered").on("click", "div", function (e) {
    var $current = $(e.currentTarget),
      index = $current.index();
    $(".container_delivered > div").removeClass("active-container");
    $current.addClass("active-container");
    $(".container_delivered-content > div").hide();
    $(".container_delivered-content > div").eq(index).show();
  });
  $(".container_delivered > div:first-child").addClass("active-container");
});

/* Customer testimonial */
$(".cs-customer-testimonial").slick({
  centerMode: true,
  centerPadding: "60px",
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 1000,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: true,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
    {
      breakpoint: 767,
      settings: {
        arrows: true,
        centerMode: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
  ],
});

/* Smart-structure slider */
$(".smart-manufacture").slick({
  infinite: true,
  slidesToShow: 3,
  dots: true,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: true,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        arrows: true,
        slidesToShow: 1,
      },
    },
  ],
});

/* homepage tab counter */
document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".counter__numbers");

  function startCounters() {
    counters.forEach((counter) => {
      const rect = counter.getBoundingClientRect();
      if (
        !counter.classList.contains("counted") &&
        rect.top >= 0 &&
        rect.bottom <= window.innerHeight
      ) {
        counter.classList.add("counted");

        // Get and clean the target count
        const rawCount = counter.getAttribute("tab-data-count").trim();
        const targetCount = parseInt(rawCount, 10);

        if (isNaN(targetCount) || rawCount === '') {
          // Handle non-numeric or empty values
          counter.textContent = rawCount || "N/A"; // Display original value or "N/A"
          return; // Skip the animation for this counter
        }

        let currentCount = 0;
        const increment = Math.ceil(targetCount / 100);

        const interval = setInterval(() => {
          currentCount += increment;
          counter.textContent = Math.min(currentCount, targetCount);
          if (currentCount >= targetCount) clearInterval(interval);
        }, 10);
      }
    });
  }

  window.addEventListener("scroll", startCounters);
  startCounters();
});

/* Gallery Accordian Js */

// $(document).ready(function () {
//   $(".accordion-list .gallery").hide(); // Hide all galleries initially
//   $(".accordion-list h3").click(function () {
//     var gallery = $(this).nextAll(".gallery").first(); // Find the corresponding gallery
//     if ($(this).hasClass("active")) {
//       $(this).removeClass("active");
//       gallery.slideUp();
//     } else {
//       $(".accordion-list h3.active")
//         .removeClass("active")
//         .nextAll(".gallery")
//         .first()
//         .slideUp();
//       $(".accordion-list h3.active").removeClass("active"); // Remove active class from all other headings
//       $(this).addClass("active");
//       gallery.slideDown();
//     }
//     return false;
//   });

//   // Open the first dropdown automatically
//   $(".accordion-list h3:first").addClass("active").next(".gallery").slideDown();
// });

// FAQ Slide Smooth //
document.addEventListener("DOMContentLoaded", function () {
  var faqContainer = document.querySelector(".faq");
  var headerHeight = document.querySelector("header").offsetHeight;

  if (faqContainer) {
    var tabs = document.querySelectorAll(".slide-heading");
    if (tabs.length > 0) {
      tabs[0].classList.add("active");
      faqContainer.addEventListener("click", function (event) {
        var target = event.target;
        if (
          target.classList.contains("slide-heading") &&
          target.parentElement.hasAttribute("href")
        ) {
          event.preventDefault();
          tabs.forEach(function (tab) {
            tab.classList.remove("active");
          });
          target.classList.add("active");
          var targetText = target.textContent.trim();
          var faqGroups = document.querySelectorAll(".faq__group");
          faqGroups.forEach(function (faqGroup) {
            var faqTitle = faqGroup.querySelector(".faq__group-title");
            if (faqTitle && faqTitle.textContent.trim() === targetText) {
              var offset = faqGroup.getBoundingClientRect().top;
              window.scrollBy({
                top: offset - headerHeight - 50,
                behavior: "smooth",
              });
              faqTitle.classList.add("active");
            } else {
              faqTitle.classList.remove("active");
            }
          });
        }
      });
    }
  }
});

/* Product tabs */
$(function () {
  var $contentlis = $(".product-tabs_inner");
  var $product_tabslis = $(".product-tabs li");

  // Show content of active tab on load
  $contentlis.first().show();
  $product_tabslis.first().addClass("product-active-tabs"); // Add active class to the first tab

  $(".product-tabs").on("click", "li", function (e) {
    var $current = $(e.currentTarget);
    var index = $current.index();

    $product_tabslis.removeClass("product-active-tabs");
    $current.addClass("product-active-tabs");
    $contentlis.hide().eq(index).show();
  });
});

/* Product slider */
$(".flickity-button").click(function () {
  $(".product-gallery__carousel-item").removeClass(
    "product-gallery__carousel-item--hidden"
  );
});

/* Quantity */
// $(document).ready(function () {
//   $(".quantity-selector__button").on("click", function () {
//     var $button = $(this);
//     var oldValue = $button.parent().find(".quantity-selector__value").val();
//     var newVal;
//     if ($button.data("action") === "increase-picker-quantity") {
//       newVal = parseFloat(oldValue) + 1;
//     } else {
//       if (oldValue > 0) {
//         newVal = parseFloat(oldValue) - 1;
//       } else {
//         newVal = 0;
//       }
//     }
//     $button.parent().find(".quantity-selector__value").val(newVal);
//   });
// });

/* Gird and list view class */
$(document).ready(function () {
  function changeLayout(event) {
    const layoutMode = $(this).data("layout-mode");
    if (layoutMode === "list") {
      $(".cs-collection-view")
        .addClass("layout__section--list")
        .removeClass("layout__section--grid");
    } else {
      $(".cs-collection-view")
        .addClass("layout__section--grid")
        .removeClass("layout__section--list");
    }
  }
  const initialLayoutMode = $(".collection__layout-button.is-selected").data(
    "layout-mode"
  );
  if (initialLayoutMode === "list") {
    $(".cs-collection-view")
      .addClass("layout__section--list")
      .removeClass("layout__section--grid");
  } else {
    $(".cs-collection-view")
      .addClass("layout__section--grid")
      .removeClass("layout__section--list");
  }
  $(".cs-collection-view").on(
    "click",
    ".collection__layout-button",
    changeLayout
  );
});

/* Collection filter menu */
$(document).ready(function () {
  $(".cs-main-collection").click(function (event) {
    if (!$(event.target).closest(".collection__filter-linklist").length) {
      $(this).toggleClass("filter-active");
      $(this).find(".collection__filter-linklist").slideToggle(100);
    }
  });

  $(".collection__filter-linklist").click(function (event) {
    event.stopPropagation();
  });
});

/* Contact form tabs */
$(function () {
  var $contentDivs = $(".contact-details-content .contact-info-content"),
    $contactDetails = $(".contact-details .contact-info");

  // Show content of first contact-info on load
  $contentDivs.first().show();
  $contactDetails.first().addClass("active-container-inner");

  $(".contact-details").on("click", ".contact-info", function (e) {
    var $current = $(e.currentTarget),
      index = $current.index();

    $contactDetails.removeClass("active-container-inner");
    $current.addClass("active-container-inner");
    $contentDivs.hide().eq(index).show();
  });
});

/* Filter blogpage */
$(document).ready(() => {
  let qsRegex;

  const $grid = $(".grid").isotope({
    itemSelector: ".element-item",
    layoutMode: "fitRows",
    filter: function () {
      const tagFilter = $("#tag-dropdown").val().toLowerCase();

      const isTagMatch =
        tagFilter === "all" ||
        $(this).data("tags").toLowerCase().includes(tagFilter);

      return qsRegex ? $(this).text().match(qsRegex) && isTagMatch : isTagMatch;
    },
  });

  $("#search").on("keyup", () => {
    qsRegex = new RegExp($("#search").val(), "gi");
    $grid.isotope();
  });

  $("#tag-dropdown").on("change", () => {
    $grid.isotope();
  });
});

/* Header menu images on hover */
$(document).ready(function () {
  $(".cs-mega-menu__title").hover(
    function () {
      var imageUrl = $(this).data("image");
      var title = $(this).data("title");
      if (imageUrl && !imageUrl.includes("no-image")) {
        $(".menu-image").attr("src", imageUrl);
        $(".menu-image").show();
        $(".on-hover-hide").hide();
        $(".on-hover-show").show();
      } else {
        $(".menu-image").attr("src", "");
        $(".menu-image").hide();
        $(".on-hover-hide").show();
        $(".on-hover-show").hide();
      }

      if (title) {
        $(".cs-mega-menu__image-text").text(title);
      }
    },
    function () {
      var defaultImageUrl = $(".menu-image").data("default-image");
      var defaultText = $(".cs-mega-menu__image-text").data("default-title");
      $(".menu-image").attr("src", defaultImageUrl);
      $(".cs-mega-menu__image-text").text(defaultText);
      $(".menu-image").show(); // Show the default image when hovering out
      $(".on-hover-show").hide();
      $(".on-hover-hide").show();
    }
  );
});

// Header menu Hover
$(document).ready(function () {
  $(".on-hover-show").hide();
  $(".cs-mega-menu__title").hover(
    function () {
      $(".on-hover-show").show();
    },
    function () {
      $(".on-hover-show").hide();
    }
  );
});

// Enquiry Button
/* BuildGravity 2026-09-04: the "Enquire now" CTA on product pages.
   This used to click #omgrfq_colletion_<id>, an element the OMG Request-a-Quote app
   injected. That app was switched off on 2026-09-03 at Dylan's request, so the trigger
   below matched nothing and jQuery silently did nothing - a prominent CTA that looked
   alive and was dead. Route it through the same handler as the other quote CTAs.
   Note the .cs-enquiry markup in product-item-v2/v4 is inside {% comment %} blocks and
   never renders, so product pages are the only surface this affects. */
jQuery(document).ready(function () {
  jQuery(document).on("click", ".cs-enquiry", function (e) {
    e.preventDefault();
    jQuery(".modal__close").trigger("click");
    triggerButton();
  });
});

/* product trigger  */
function triggerButton() {
  /* The "Get the price here" / "Get a quote" CTA.
     This used to open the OMG Request-a-Quote popup. That app was switched off on
     2026-09-03 at Dylan's request, so the lookup below now finds ZERO elements and the
     guard makes it fail silently - a prominent CTA that does nothing when clicked, with
     no error to notice. Point it at the GHL inquiry form that replaced it, which is on
     the same page. The legacy branch is kept last so re-enabling the app restores the
     old behaviour without another code change. */
  var form = document.querySelector(".bg-ghl-form__frame, .bg-ghl-form");
  if (form) {
    form.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }
  /* No inline form on this page (the ~54 marketing and specification pages have
     none). Fall back to the site-wide quote modal from snippets/bg-quote-modal. */
  if (typeof window.bgOpenQuoteModal === "function") {
    window.bgOpenQuoteModal();
    return;
  }
  var buttons = document.getElementsByClassName("omgrfq-btn-quotes");
  if (buttons.length > 0) {
    buttons[0].click();
  }
}

/* Shopify announcement bar*/
$(document).ready(function () {
  // Initialize slick slider
  $("#cs-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2500,
  });
  setTimeout(function () {
    $("#cs-slider").css("visibility", "visible").hide().fadeIn(500);
  }, 100);
});

/* smart structure expand content after button click */
// $(document).ready(function () {
//   var maxLength = 100;
//   $(".structure-content").each(function () {
//     var $this = $(this); // Cache the current structure-content element
//     var contentElement = $this.find("p");
//     var fullText = contentElement.text();

//     if (fullText.length > maxLength) {
//       var truncatedText = fullText.substring(0, maxLength) + "...";
//       contentElement.text(truncatedText);

//       $this.find(".read-more-link").click(function () {
//         var linkElement = $(this);
//         if (linkElement.data("expanded")) {
//           contentElement.text(truncatedText);
//           linkElement
//             .data("expanded", false)
//             .html(
//               'Read More <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none"><path d="M12.5303 6.53033C12.8232 6.23744 12.8232 5.76256 12.5303 5.46967L7.75736 0.696699C7.46447 0.403806 6.98959 0.403806 6.6967 0.696699C6.40381 0.989593 6.40381 1.46447 6.6967 1.75736L10.9393 6L6.6967 10.2426C6.40381 10.5355 6.40381 11.0104 6.6967 11.3033C6.98959 11.5962 7.46447 11.5962 7.75736 11.3033L12.5303 6.53033ZM0 6.75H12V5.25H0V6.75Z" fill="white"></path></svg>'
//             );
//         } else {
//           contentElement.text(fullText);
//           linkElement
//             .data("expanded", true)
//             .html(
//               'Read Less <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none"><path d="M12.5303 6.53033C12.8232 6.23744 12.8232 5.76256 12.5303 5.46967L7.75736 0.696699C7.46447 0.403806 6.98959 0.403806 6.6967 0.696699C6.40381 0.989593 6.40381 1.46447 6.6967 1.75736L10.9393 6L6.6967 10.2426C6.40381 10.5355 6.40381 11.0104 6.6967 11.3033C6.98959 11.5962 7.46447 11.5962 7.75736 11.3033L12.5303 6.53033ZM0 6.75H12V5.25H0V6.75Z" fill="white"></path></svg>'
//             );
//         }
//       });
//     } else {
//       $this.find(".read-more-link").hide();
//     }
//   });
// });

/* on load body class */
$(document).ready(function () {
  let isScrollingClassAdded = false;
  $(window).scroll(function () {
    let scrollTop = $(window).scrollTop();
    if (scrollTop > 0 && !isScrollingClassAdded) {
      $("body").addClass("scrolling");
      isScrollingClassAdded = true;
    } else if (scrollTop === 0 && isScrollingClassAdded) {
      $("body").removeClass("scrolling");
      isScrollingClassAdded = false;
    }
  });
  $("#bottom-arrow").click(function (event) {
    event.preventDefault();
    $("html, body").animate({ scrollTop: $(document).height() }, 1000);
  });
});


/* mobile announcement bar*/
$(document).ready(function () {
  // Initialize slick slider
  $("#cs-mobile-sliders").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2500,
  });

  setTimeout(function () {
    $("#cs-mobile-sliders").css("visibility", "visible").hide().fadeIn(500);
  }, 100);
});


/* active class on collection filter */
$(document).ready(function() {
    $('.collection-filter-seabox').click(function() {
        $('.collection-filter-seabox').removeClass('active');
        $(this).addClass('active');
    });
});




$(document).ready(function() {
  // Function to update variant details based on selected type and size
  function updateVariantDetails() {
    var type = $('.sea-radio-choose-type:checked').data('optionclass');
    var size = $('.sea-radio-choose-size:checked').data('optionclass');
    var finalClass = type + '--' + size;

    // Update the variant-name with the selected type and size
    $('#variant-name').text(finalClass);

    // Hide all variant details
    $('.variant-details').hide();

    // Show the details of the variant that matches the finalClass
    $('.variant-details.' + finalClass).show();
  }

  // Bind updateVariantDetails to radio button change events
  $('.sea-radio-choose-type, .sea-radio-choose-size').change(function() {
    updateVariantDetails();
  });

  // Initial call to set the correct variant details on page load
  updateVariantDetails();
});


$(document).ready(function() {
  // Listen for change events on the radio buttons
  $('.block-swatch__radio').on('change', function() {
    // Get the title attribute from the corresponding label
    var label = $('label[for="' + this.id + '"]');
    var title = label.attr('title');

    // Update the text of the <h3> element with the id "variant-name"
    $('#variant-name').text(title);
  });
});



document.addEventListener('DOMContentLoaded', function() {
    /* BuildGravity 2026-09-04: added the null guards. This block is PRE-EXISTING and
       byte-identical on the live theme - it is not a regression from our work - but it
       dereferences .cs-product-inner_content and .product-button-quick without checking
       either, so on any page that lacks them it throws
       "Cannot read properties of null (reading 'querySelector')" and aborts the rest of
       this handler. Guarding it is free and removes a real console exception. */
    var productAvailable = document.querySelector('.cs-product-inner_content');
    if (!productAvailable) return;
    var productButtonQuick = productAvailable.querySelector('.product-button-quick');
    if (!productButtonQuick) return;
    var anchors = productButtonQuick.querySelectorAll('a');

    if (anchors.length === 1) {
        productAvailable.classList.add('single-anchor');
    }
});


